import { useIonAlert } from "@ionic/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isCompatibleBrowserPushNotification } from "./pushnotification";

export const useCheckNotificationPermission = () => {
    const [isPresentNotification, setIsPresentNotification] = useState<boolean>(false);
    const [presentAlert] = useIonAlert();
    const { t } = useTranslation("common");

    useEffect(() => {
        if (isCompatibleBrowserPushNotification()) {
            if (Notification.permission === "denied" && !isPresentNotification) {
                setIsPresentNotification(true);
                presentAlert({
                    header: t("GLOBAL.WARNING"),
                    cssClass: "custom-alert",
                    backdropDismiss: false,
                    message: t("MESSAGES.NOTIFICATION_WARNING"),
                    buttons: [
                        {
                            text: t("GLOBAL.ACCEPT"),
                            role: "cancel",
                        },
                    ],
                }).catch(() => {});
            }
        }
    }, [isPresentNotification]);
};
